export type FilterType = {
  focus?: boolean
  key?: string
  type: string
  values?: {
    /* eslint-disable typescript-sort-keys/interface */
    w?: boolean
    u?: boolean
    b?: boolean
    r?: boolean
    g?: boolean
    c?: boolean
    /* eslint-enable typescript-sort-keys/interface */
    checked?: boolean
    operator?: string
    sets?: string[]
    value?: string | string[]
  }
}

export const DEFAULT_FILTER_VALUE = {
  checked: true,
  operator: '>',
  value: '',
}

const DEFAULT_RARITY_FILTER_VALUE = {
  value: 'common',
}

const DEFAULT_COLOR_FILTER_VALUE = {
  // eslint-disable-next-line sort/object-properties
  w: false,
  u: false,
  b: false,
  r: false,
  g: false,
  c: false,
  operator: 'EXCLUSIVE ALL',
}

const DEFAULT_SETS_FILTER_VALUE = {
  operator: 'INCLUDE',
  value: '',
}

export const DEFAULT_FILTER_VALUE_MAP = {
  colors: DEFAULT_COLOR_FILTER_VALUE,
  manaValue: DEFAULT_FILTER_VALUE,
  power: DEFAULT_FILTER_VALUE,
  price: DEFAULT_FILTER_VALUE,
  rarity: DEFAULT_RARITY_FILTER_VALUE,
  sets: DEFAULT_SETS_FILTER_VALUE,
  toughness: DEFAULT_FILTER_VALUE,
}

export const NAME_MAP = {
  cardName: 'Card Name',
  colors: 'Colors',
  inclusion: 'Inclusion %',
  manaValue: 'Mana Value',
  num_decks: 'Deck #',
  power: 'Power',
  price: 'Price',
  rarity: 'Rarity',
  salt: 'Salt',
  sets: 'Sets',
  synergy: 'Synergy %',
  tags: 'Tags',
  toughness: 'Toughness',
  typeLine: 'Type Line',
  universesBeyond: 'Universes Beyond',
}
